import { extractJSON } from '../services/jsonUtil';
import { getItem, removeItem } from './cache';
import { LOCAL_STORAGE_CONSTANT } from '../constants/app';
import {
  doCreateOrderRequest,
  doOfflineCartRequest,
} from '../store/action/checkout';
import { getCartInfoRequest } from '../api/checkout';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Process items stored in offline cart once user is authenticated.
 *
 * Options:
 * - dispatch: Redux dispatch function (required)
 * - onStart: optional callback invoked before processing (e.g., show loader)
 * - onEnd: optional callback invoked after processing (e.g., hide loader)
 */
export const processOfflineCart = async ({ dispatch, onStart, onEnd } = {}) => {
  if (!dispatch) {
    throw new Error('processOfflineCart requires a Redux dispatch function');
  }

  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  const offlineCartRaw = getItem('offlineCart');
  const OfflineCartData = JSON.parse(offlineCartRaw);

  if (!!user && OfflineCartData?.length) {
    if (typeof onStart === 'function') onStart();
    try {
      for (const item of OfflineCartData || []) {
        const product = {
          ...item?.attributes,
          id: item?.attributes?.product_id,
        };

        // Add each offline cart item to the server-side cart
        // and add a tiny delay to avoid race conditions
        // during back-to-back additions
        // eslint-disable-next-line no-await-in-loop
        await dispatch(doOfflineCartRequest({ product }));
        // eslint-disable-next-line no-await-in-loop
        await delay(500);
      }

      // Refresh cart server-side and then attempt order creation
      await getCartInfoRequest();
      dispatch(doCreateOrderRequest());

      // Cleanup flags and offline cart
      removeItem('offlineCart');
      removeItem('checkoutFromSignup');
      removeItem('isOfflineCheckout');
      return true;
    } finally {
      if (typeof onEnd === 'function') onEnd();
    }
  }

  return false;
};
